const parseHtmlAttrs = (s: string) => {
  const r = /([a-z]+)="([^"]+)"/g; // (is stateful)
  let m: RegExpExecArray | null;
  const out: { [key: string]: string | undefined } = {};
  while ((m = r.exec(s)) !== null) {
    out[m[1]] = m[2];
  }
  return out;
};

const parseWpImageUrl = (s: string) => {
  const m = /^(.*)-([0-9]+)x([0-9]+)(\.[^-\/]+)$/.exec(s);
  return {
    url: m ? `${m[1]}${m[4]}` : s,
    w: m?.[2],
    h: m?.[3],
  };
};

const setAttr = (s: string, attr: string, value: string) =>
  s.includes(`${attr}="`)
    ? s.replace(new RegExp(`${attr}="[^"]+"`), `${attr}="${value}"`)
    : `${s} ${attr}="${value}"`;

const setAttrs = (s: string, values: { attr: string; value: string }[]) =>
  values.reduce((acc, { attr, value }) => setAttr(acc, attr, value), s);

const addServerAddress = (url: string) =>
  url.replace(
    /(^\/wp-content\/)/,
    `${process.env.NEXT_PUBLIC_WORDPRESS_URL || process.env.WORDPRESS_URL}$1`
  );

const nextImageUrl = (url: string, w = 640, q = 75) =>
  `/_next/image?url=${encodeURIComponent(addServerAddress(url))}&w=${w}&q=${q}`;

const nextImageSrcset = (
  url: string,
  widths = [384, 640, 750, 828, 1080],
  q = 75
) => widths.map((w) => `${nextImageUrl(url, w, q)} ${w}w`).join(', ');

const tweakAttrs = (s: string) => {
  const imgSrc = parseHtmlAttrs(s)['src'];
  if (!imgSrc) {
    return s;
  }
  const { url } = parseWpImageUrl(imgSrc);
  return setAttrs(s, [
    { attr: 'src', value: nextImageUrl(url, 640) },
    { attr: 'srcset', value: nextImageSrcset(url) },
    { attr: 'sizes', value: '(min-width: 1024px) 720px, 100vw' },
  ]);
};

export const fixPostImageTag = <T extends string | undefined | null>(s: T) =>
  s
    ? s.replace(
        /(<img\s)([^>]+)(>)/g,
        (_, p1, p2, p3) => `${p1}${tweakAttrs(p2)}${p3}`
      )
    : s;
